<div *transloco="let t; prefix:''" class="modal-body vh-100 text-primary">
  <div class="row">
    <div class="col">
      <a class="navbar-brand d-block" href="'/'">
        <img alt="" class="sidebar-logo m-auto" src='/assets/logo_dark.png'>
      </a>
    </div>
    <div class="col-auto d-flex align-items-center">
      <button (click)="activeModal.dismiss('Cross click')" aria-label="Close" class="btn-close" style="font-size: 40px;"
              type="button"></button>
    </div>
  </div>
  <nav class="row pt-5">
    <app-sidebar [sidebarClasses]="'w-100 sidebar-mobile'"></app-sidebar>
  </nav>
</div>
